import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import PdfModalForm from './PdfModalForm';

import ModalDialog from '../../ModalDialog/ModalDialog';

const PdfModal = (props) => {
	const { author, open, onClose, onApply, className, pdf, filename, ...rest } = props;

	return (
		<ModalDialog
			maxWidth="xl"
			onClose={onClose}
			open={open}
			title={'' || filename}
			hasConfirm={false}
			cancelLabel="Close"
		// confirmLabel="Save"
		// onConfirmClicked={null}
		>
			<PdfModalForm pdf={pdf} />
		</ModalDialog>
	);
};

PdfModal.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	pdf: PropTypes.string,
	filename: PropTypes.string
};

export default PdfModal;
